<script setup>
import BaseModal from "@/components/global-themed/BaseModal.vue";
import KitIcon from "@/components/approval-center/partials/kit/KitIcon.vue";
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";
import {useQuery} from "@tanstack/vue-query";
import axios from "axios";
import {ref} from "vue";
import {Steps} from "@/composables/ai-onboarding/useSteps";
import useKit from "@/composables/useKit";

const {canSeeKit} = useKit();

const props = defineProps({
  step: {
    type: Object,
    required: true,
  }
});

const open = ref(false);

const stepSummaryEndpoint = {
  [Steps.KEYWORDS.key]: {
    url: Steps.HOLDING.aiSummaryUrlPath,
    key: Steps.HOLDING.key,
  },
  [Steps.PAGES.key]: {
    url: Steps.AI_AUTO_ASSIGN_HOLDING.aiSummaryUrlPath,
    key: Steps.AI_AUTO_ASSIGN_HOLDING.key,
  },
};

const selectedStep = stepSummaryEndpoint[props.step.key];

const { data: aiSummaryMessage } = useQuery({
  queryKey: ['ai-summary-message', selectedStep.key],
  queryFn: async () => {
    const {data} = await axios.get(selectedStep.url);

    return data.data;
  },
});

</script>

<template>
  <DefaultButton @click="open = true">
    Here's my summary
  </DefaultButton>

  <Teleport to=".tailwind">
    <BaseModal
      v-if="open"
      modal-class="tw-max-w-[800px]"
      @close="open = false"
    >
      <div class="tw-p-4 tw-pt-0 tw-space-y-6">
        <div class="tw-flex tw-gap-4 tw-items-center">
          <KitIcon v-if="canSeeKit" />
          <h2 class="tw-text-grey-dark tw-font-bold tw-text-4.5xl">
            Here's my summary
          </h2>
        </div>

        <p class="mb-2 tw-text-base">
          {{ aiSummaryMessage }}
        </p>

        <DefaultButton
          class="tw-w-auto tw-mx-auto"
          @click="open = false"
        >
          Close
        </DefaultButton>
      </div>
    </BaseModal>
  </Teleport>
</template>
